import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AddOnPackage } from 'app/add-on-packages/add-on-package.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class AddOnPackagesService {
    private apiBaseUrl: string;

    constructor(private httpClient: HttpClient) {
        this.apiBaseUrl = environment.backEnd + '/api/addOnPackageAdmin';
    }

    // Loads the complete draft package catalogue in one request.
    getPackages(): Observable<AddOnPackage[]> {
        return this.httpClient.get<AddOnPackage[]>(this.apiBaseUrl);
    }

    // Loads one package for editing.
    getPackage(id: string): Observable<AddOnPackage> {
        return this.httpClient.get<AddOnPackage>(`${this.apiBaseUrl}/${id}`);
    }

    // Creates a draft catalogue package.
    createPackage(addOnPackage: AddOnPackage): Observable<AddOnPackage> {
        return this.httpClient.post<AddOnPackage>(this.apiBaseUrl, addOnPackage);
    }

    // Updates a draft catalogue package.
    updatePackage(addOnPackage: AddOnPackage): Observable<AddOnPackage> {
        return this.httpClient.put<AddOnPackage>(
            `${this.apiBaseUrl}/${addOnPackage.id}`,
            addOnPackage);
    }
}
